// extracted by mini-css-extract-plugin
module.exports = {"headline":"roomstay-blog-text-footer_headline__XccoE","subHeadline":"roomstay-blog-text-footer_subHeadline__w1kR_"};